// src/components/Footer.jsx
import React from "react";

export default function Footer() {
  return (
    <footer
      id="footer"
      style={{
        background: "#0b2447",
        color: "#fff",
        padding: "40px 24px 32px",
      }}
    >
      <div className="content-wrapper" style={{ maxWidth: 1440, margin: "0 auto" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 40,
        }}
      >
        <div>
          <h4 style={{ fontWeight: "bold", marginBottom: 12 }}>PRODUCT</h4>
          <button
            onClick={() => (window.location.href = "/")}
            style={{
              background: "none",
              border: "none",
              padding: 0,
              color: "#00b4d8",
              cursor: "pointer",
              font: "inherit",
            }}
          >
            Smart Audit
          </button>
        </div>
        <div>
          <h4 style={{ fontWeight: "bold", marginBottom: 12 }}>RESOURCES</h4>
          <p
            onClick={() =>
              window.open("/datasheet", "_blank", "noopener,noreferrer")
            }
            style={{ color: "#00b4d8", cursor: "pointer", marginBottom: 6 }}
          >
            Datasheet
          </p>
          <p style={{ color: "#00b4d8", cursor: "pointer", marginBottom: 6 }}>
            Demos
          </p>
          <p style={{ color: "#00b4d8", cursor: "pointer", marginBottom: 0 }}>
            Videos
          </p>
        </div>
        <div style={{ maxWidth: 400 }}>
          <h4 style={{ fontWeight: "bold", marginBottom: 12 }}>
            CONTACT INFORMATION
          </h4>
          <div style={{ color: "#9CC2DF", lineHeight: 1.6, fontSize: 14 }}>
            <div>
              <b style={{ color: "#7CC4FF" }}>Address:</b> 75/51 Ocean Tower 2
              Building, Room 51A, 24th Floor, Sukhumvit Soi 19, Sukhumvit Road,
              Khlong Toei Nuea Subdistrict, Watthana District, Bangkok 10110
            </div>
            <div style={{ marginTop: 10 }}>
              <b style={{ color: "#7CC4FF" }}>Email:</b> info@smartclick.co.th
            </div>
            <div style={{ marginTop: 10 }}>
              <b style={{ color: "#7CC4FF" }}>Tel:</b> (+66)02-664-2926
            </div>
          </div>
        </div>
        <div style={{ maxWidth: 400, color: "#9ecae1", fontSize: 14 }}>
          <p>
            <span style={{ color: "#00b4d8" }}>Smart Click</span> provides
            advanced license management and audit automation solutions through
            our flagship product, Smart Audit, ensuring simple, secure, and
            reliable operations to protect digital infrastructures and enterprise
            environments. Quality, security, and transparency are at the heart of
            everything we do.
          </p>
        </div>
      </div>
      <div
        style={{
          marginTop: 32,
          textAlign: "center",
          fontSize: 13,
          color: "#ccc",
          borderTop: "1px solid rgba(148,163,184,.35)",
          paddingTop: 16,
        }}
      >
        Copyright © 2025. Designed by{" "}
        <a
          href="https://www.smartclick.co.th"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#00b4d8" }}
        >
          Smartclick Solution Co.,Ltd
        </a>
      </div>
      </div>
    </footer>
  );
}
